import React from 'react';
import { Download, CheckCircle, XCircle, Clock } from 'lucide-react';

const BillingHistory = ({ transactions }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'succeeded':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'failed':
        return <XCircle className="w-5 h-5 text-red-500" />;
      case 'pending':
        return <Clock className="w-5 h-5 text-yellow-500" />;
      default:
        return null;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'succeeded':
        return 'text-green-600 bg-green-100';
      case 'failed':
        return 'text-red-600 bg-red-100';
      case 'pending':
        return 'text-yellow-600 bg-yellow-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  if (!transactions || transactions?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="text-gray-400 mb-4">
          <Download className="w-12 h-12 mx-auto" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No Billing History</h3>
        <p className="text-gray-600">Your payment transactions will appear here once you upgrade to Pro.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Billing History</h2>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Date</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Description</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Amount</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Status</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Invoice</th>
            </tr>
          </thead>
          <tbody>
            {transactions?.map((transaction) => (
              <tr key={transaction?.id} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-4 px-4 text-sm text-gray-900">
                  {new Date(transaction?.createdAt)?.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </td>
                <td className="py-4 px-4 text-sm text-gray-700">
                  {transaction?.description || 'Pro Subscription'}
                </td>
                <td className="py-4 px-4 text-sm font-semibold text-gray-900">
                  ${(transaction?.amount / 100)?.toFixed(2)} {transaction?.currency?.toUpperCase()}
                </td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-2">
                    {getStatusIcon(transaction?.status)}
                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${getStatusColor(transaction?.status)}`}>
                      {transaction?.status?.charAt(0)?.toUpperCase() + transaction?.status?.slice(1)}
                    </span>
                  </div>
                </td>
                <td className="py-4 px-4 text-right">
                  {transaction?.stripeInvoiceId && (
                    <button
                      onClick={() => window.open(`https://invoice.stripe.com/i/${transaction?.stripeInvoiceId}`, '_blank')}
                      className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-700 text-sm font-medium"
                    >
                      <Download className="w-4 h-4" />
                      Download
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {transactions?.length > 5 && (
        <div className="mt-4 text-center">
          <button className="text-blue-600 hover:text-blue-700 text-sm font-medium">
            View All Transactions
          </button>
        </div>
      )}
    </div>
  );
};

export default BillingHistory;